import "../resource_collection/behavior.js";

// Each behavior must be registered with the name of the component template
class LocationsBehavior extends Sparkle.PageBuilder.Components.ResourceCollectionAbstractBehavior {}
LocationsBehavior.register("locations");
